export enum ProductTypes {
  SMJ = 'SMJ',
  IZL = 'IZL',
  CAR = 'CAR',
}

export enum EProductPaymentTypes {
  fixed = 'fixed',
  percentage = 'percentage',
}
